import { Logger } from '@school-manage/utils/logger';
import {
  type PersistedClient,
  type Persister,
} from '@tanstack/react-query-persist-client';

import { getItem, removeItem, setItem } from './common';

function createIDBPersister(idbValidKey: IDBValidKey = 'query-cache') {
  return {
    persistClient: async (client: PersistedClient) => {
      // Fix DataCloneError error
      if (
        client.clientState.queries.find(
          (query) => query.state.fetchFailureReason
        )
      ) {
        Logger.debug('Skipping persisting client due to errors');
        return;
      }

      await setItem(idbValidKey, client);
    },
    removeClient: async () => {
      await removeItem(idbValidKey);
    },
    restoreClient: async () => {
      return getItem<PersistedClient>(idbValidKey);
    },
  } as Persister;
}

export const TanstackQueryIDBPersister = createIDBPersister();
